import { render, staticRenderFns } from "./xiangjiao.vue?vue&type=template&id=75ad8b9a&scoped=true"
import script from "./xiangjiao.vue?vue&type=script&lang=js"
export * from "./xiangjiao.vue?vue&type=script&lang=js"
import style0 from "./xiangjiao.vue?vue&type=style&index=0&id=75ad8b9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ad8b9a",
  null
  
)

export default component.exports